import script from "./ListOfDuplicatedUploadsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ListOfDuplicatedUploadsModal.vue?vue&type=script&setup=true&lang=ts"

import "./ListOfDuplicatedUploadsModal.vue?vue&type=style&index=0&id=89ed5188&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89ed5188"]])

export default __exports__